import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {resolve} from "../../../../container";
import {Dictionary} from "../../../../page/elements/dictionary";
import Styles from "./newsSearchResults.lit.scss";
import {NewsSearchBackend} from "../newsSearchBackend";
import {FilteredSearch} from "../filteredSearch";
import type {Maybe, Nullable} from "../../../../bootstrap/common/types";
import {EopNewsSearchResultsTiles} from "./newsSearchResultsTiles";
import {trackingTextlinkInteract} from "../../../../tracking/trackingAttributes";

@customElement("eop-news-search-results")
export class EopNewsSearchResults extends FilteredSearch {

    public static readonly styles = Styles;

    @property({attribute: "back-link-href"})
    private backLinkHref: string;

    @query("eop-news-search-results-tiles")
    private tiles: EopNewsSearchResultsTiles;

    public constructor(backend: NewsSearchBackend = resolve(NewsSearchBackend)) {
        super(false);
        this.searchFacade.registerBackend(backend);
    }

    public render(): TemplateResult {
        return html`
            <eop-overlay-spinner event="search,more" class="content-search-spinner"></eop-overlay-spinner>
            ${this.renderResultsLabel()}
            <eop-news-search-results-tiles class="tiles"></eop-news-search-results-tiles>
            ${this.renderSearchTags()}
            <div class="footer">
                ${this.renderMoreButton()}
                ${this.renderBackLink()}
            </div>`;
    }

    private renderSearchTags(): Nullable<TemplateResult> {
        if (this.searchFacade.totalCount() !== 0) {
            return null;
        }

        return html`
            <eop-search-tags .tags=${this.tags} .targetUrl=${this.targetUrl} class="initial"></eop-search-tags>`;
    }

    private renderBackLink(): Nullable<TemplateResult> {
        if (!this.searchFacade.activeGroup() || !this.backLinkHref) {
            return null;
        }

        const label = Dictionary.of(this).translate("NEWSROOM_BACK");
        return html`
            <div class="content-search-back-link">
                <a href=${this.backLinkHref} class="link link-prev" ${trackingTextlinkInteract(label, this.backLinkHref)}>${label}</a>
            </div>`;
    }

    protected lastFocusable(): Maybe<HTMLElement> {
        return this.tiles.lastFocusable();
    }
}
